import React, { useState, useMemo } from 'react';
import { SxStyle } from '../../../../types';
import Typography from '@mui/material/Typography';
import TeamsPopover from './teams-popover';
import { PermissionsTeam, TeamMinimized } from '../types';
import Box from '@mui/material/Box';
import { getTeamName } from '../helpers';

const styles: SxStyle = {
  compact: (theme) => ({
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  }),
  textContainer: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  text: (theme) => ({
    display: 'inline',
    marginRight: '5px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }),
};

interface Props {
  appTeams: TeamMinimized[];
  permissionsTeam: PermissionsTeam;
  minimized?: boolean;
}

const UserTeamsRoles = ({ appTeams, permissionsTeam, minimized }: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [popoverAbbrvs, setPopoverAbbrvs] = useState<string[]>([]);

  const compactTeamAbbrvs = useMemo(() => {
    return Object.entries(permissionsTeam).reduce(
      (acc, [, teamAbbrvs]) => [...acc, ...teamAbbrvs],
      [] as string[]
    );
  }, [permissionsTeam]);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>, teamAbbrvs: string[]) => {
    setAnchor(event.currentTarget);
    setPopoverAbbrvs(teamAbbrvs);
  };

  const handlePopoverClose = () => {
    setAnchor(null);
  };

  return (
    <>
      <Typography
        sx={styles.compact}
        style={{ marginRight: '5px' }}
        variant="body2-bold"
        onMouseEnter={(event) => handlePopoverOpen(event, compactTeamAbbrvs)}
        onMouseLeave={handlePopoverClose}
      >
        {`${compactTeamAbbrvs.length} st`}
      </Typography>
      {Object.entries(permissionsTeam).map(([teamRole, teamAbbrvs], index) => (
        <Box sx={styles.textContainer} key={index}>
          <Typography sx={styles.text} variant="body2" style={{ textTransform: 'capitalize' }}>
            {teamRole + ':'}
          </Typography>
          {teamAbbrvs.length === 1 && !minimized ? (
            <Typography sx={styles.text} variant="body2-bold">
              {getTeamName(appTeams, teamAbbrvs[0])}
            </Typography>
          ) : (
            <Typography
              sx={styles.text}
              style={{ marginRight: '5px' }}
              variant="body2-bold"
              onMouseEnter={(event) => handlePopoverOpen(event, teamAbbrvs)}
              onMouseLeave={handlePopoverClose}
            >
              {`${teamAbbrvs.length} st`}
            </Typography>
          )}
        </Box>
      ))}
      <TeamsPopover
        appTeams={appTeams}
        teamAbbrvs={popoverAbbrvs}
        anchorEl={anchor}
        onPopoverClose={handlePopoverClose}
      />
    </>
  );
};

export default UserTeamsRoles;
